<template>
  <div class="modal-wrapper">
    <div class="modal" :class="{ 'modal--report': isComingFromReport }">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input type="text" placeholder="Търсене" v-model="searchActivities" />
        </div>
        <span class="mck modal-close" @click="close()">F</span>
        <div class="btns-select" v-if="isComingFromReport">
          <button
            class="btn btn-select"
            @click="filterByPart = ''"
            v-if="filterByPart"
          >
            <span class="mck">e</span>
            Всички дейности
          </button>
          <button
            class="btn btn-select"
            @click="activityMode = !activityMode"
            v-else
          >
            <span class="mck2">r</span>
            Изглед по {{ activityMode ? 'част' : 'дейност' }}
          </button>
          <button class="btn btn-select" @click="isEditItemWithPartOpen = true">
            <span class="mck">L</span>
            Нова дейност
          </button>
          <button
            class="btn btn-select"
            @click="toggleActivities(true)"
            :disabled="!activityMode"
          >
            <span class="mck">W</span>
            Всички
          </button>
          <button
            class="btn btn-select"
            @click="toggleActivities(false)"
            :disabled="!activityMode"
          >
            <span class="mck">X</span>
            Никой
          </button>
        </div>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <div
          v-if="!activities.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img desktop"
            src="../../assets/img/help_act.svg"
            alt="Структура на таблицата"
          />
          <img
            class="modal-content-template-img mobile"
            src="../../assets/img/help_act.svg"
            alt="Структура на таблицата"
          />
        </div>
        <div
          class="modal-content-item with-edit"
          v-for="(activity, index) in filteredActivities"
          :key="`activityModal-${index}-${activity.name}`"
          :class="{ 'modal-content-check-additional': activity.isAdditional }"
          :title="activity.name"
        >
          <p>
            <span>{{ activity.name }}</span>
            <span class="transparentish">{{ activity.part }}</span>
            <span class="transparentish"
              >{{ activity.price }} €/{{ activity.unit }},
              {{ activity.quantity || 0 }} {{ activity.unit }}
            </span>
          </p>
          <span class="mck edit" @click="editActivity(index)" title>c</span>
          <span class="mck" @click="deleteActivity(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="activities.length && !filteredActivities.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchActivities }}</strong
          >'
        </p>
      </div>
      <div class="modal-content" v-else>
        <template v-if="activityMode">
          <div
            class="modal-content-check"
            v-for="(activity, index) in filteredActivities"
            :key="`addActivities-${index}-${activity._id}`"
            :class="{
              'modal-content-check-additional': activity.isAdditional,
              'modal-content-check-planned': activity.isPlanned,
            }"
            :title="activity.name"
          >
              <!-- 'modal-content-check-disabled': activity.isPlanned, -->
            <label class="checkbox-wrapper">
              <p>
                <span>{{ activity.name }}</span>
                <span class="transparentish"
                  >{{ activity.price }} €/{{ activity.unit }},
                  {{ activity.quantity || 0 }} {{ activity.unit }}
                </span>
              </p>
              <input
                type="checkbox"
                :id="activity._id"
                v-model="activity.isSelected"
              />
                <!-- :disabled="activity.isPlanned" -->
              <span class="checkmark"></span>
            </label>
            <div class="select-wrapper" v-if="parts.length">
              <select
                v-model="activity.part"
                :class="{ 'select-grey': activity.part === '' }"
                @change="updateActivity(index)"
              >
                <!-- :disabled="activity.isPlanned" -->
                <option value disabled selected hidden
                  >Асоциирай към част</option
                >
                <!-- <option value v-if="activity.part">Премахни част</option> -->
                <option
                  v-for="(p, j) in parts"
                  :value="p"
                  :key="`${activity._id}-p-${j}`"
                  >{{ p }}</option
                >
              </select>
            </div>
          </div>
        </template>
        <template v-else>
          <p
            class="select-p"
            v-for="(p, i) in getParts"
            :key="`selectPart-${i}`"
            @click="(filterByPart = p), (activityMode = true)"
          >
            {{ p }}
          </p>
        </template>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="activities.length && !filteredActivities.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchActivities }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns">
          <button
            class="btn btn-excel"
            @click="triggerFileInput()"
            v-if="!isComingFromReport"
          >
            <span class="mck">E</span>
            Добави файл
          </button>
          <input
            ref="uploadActivities"
            class="input-hide"
            type="file"
            @change="handleFile"
          />
          <!--  -->
          <button class="btn btn-new" @click="save()">
            <span class="mck">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <!-- <EditInputModal v-if="isEditInputModalOpened" :isComingFromActivities="true"></EditInputModal> -->
    <EditItemWithPart
      v-if="isEditItemWithPartOpen"
      type="activity"
      :obj="activities[selectedIndex]"
      :parts="parts"
      @create="handleAdd"
      @edit="handleEditActivity"
      @close="closeEditItemWithPartModal"
    />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
// import EditInputModal from './EditInputModal';
import EditItemWithPart from './EditItemWithPart';
export default {
  components: {
    // EditInputModal,
    EditItemWithPart,
  },
  props: [
    'incomingActivities',
    'isComingFromReport',
    'companyId',
    'projectId',
    'objectId',
    'newestActivity',
    'toggleImport',
    'parts',
  ],
  watch: {
    incomingActivities() {
      this.initActivities();
    },
  },
  data() {
    return {
      isEditInputModalOpened: false,
      isEditItemWithPartOpen: false,
      selectedIndex: null,
      activities: [],
      searchActivities: '',
      activityMode: true,
      filterByPart: '',
    };
  },
  computed: {
    filteredActivities() {
      return this.filterActivities();
    },
    getParts() {
      const parts = [];

      for (let a of this.activities) {
        if (parts.indexOf(a.part) === -1) {
          parts.push(a.part);
        }
      }

      return parts.sort();
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadActivities.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes('име') ||
                  keys[i].toLowerCase().includes('мерна единица') ||
                  keys[i].toLowerCase().includes('мерна ед-ца') ||
                  keys[i].toLowerCase().includes('ед. цена') ||
                  keys[i].toLowerCase().includes('цена') ||
                  keys[i].toLowerCase().includes('част') ||
                  keys[i].toLowerCase().includes('количество') ||
                  keys[i].toLowerCase().includes('к-во')
                )
                // ||
                // keys[i].toLowerCase().includes('цена')
              ) {
                this.$snotify.error(
                  'Таблицата трябва да има заглавен ред с Име / Мерна ед-ца / Ед. цена / Част / Количество'
                );
                return;
              }
            }
            // ROW OBJECT
            let duplicates = 0;
            for (let item in rows[row]) {
              // // check for duplicate
              // const i = this.activities
              //   .map((a) => a.name)
              //   .indexOf(rows[row][item][Object.keys(rows[row][item])[0]]);
              // if (i > -1) {
              //   // if there's one compare the units also and if same go to next iteration and increment counter
              //   if (
              //     this.activities[i].unit ===
              //     rows[row][item][Object.keys(rows[row][item])[1]]
              //   ) {
              //     duplicates++;
              //     continue;
              //   }
              // }
              // ROW DATA
              this.activities.push({
                name: rows[row][item][Object.keys(rows[row][item])[0]],
                unit: rows[row][item][Object.keys(rows[row][item])[1]],
                price: rows[row][item][Object.keys(rows[row][item])[2]] || 0,
                part: rows[row][item][Object.keys(rows[row][item])[3]],
                quantity: rows[row][item][Object.keys(rows[row][item])[4]] || 0,
              });
            }

            if (duplicates) {
              this.$snotify.warning(
                `Игнорирани са ${duplicates} повтарящи се дейности`
              );
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error('Качените файлове трябва да бъдат .xls или .xlsx');
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterActivities() {
      return this.activities.filter((a) => {
        if (this.filterByPart) {
          return (
            a.name
              .toLowerCase()
              .includes(this.searchActivities.toLowerCase()) &&
            a.part === this.filterByPart
          );
        } else {
          return a.name
            .toLowerCase()
            .includes(this.searchActivities.toLowerCase());
        }
      });
    },
    updateActivity(i) {
      this.$set(this.activities, i, this.activities[i]);
    },
    toggleActivities(toggle) {
      // If searching select only results
      if (this.searchActivities.length) {
        const tempFilteredActivities = this.filterActivities();
        this.activities.forEach((a, index) => {
          tempFilteredActivities.forEach((fa) => {
            if (a._id === fa._id) {
              let activity = a;
              if (!activity.isPlanned) {
                activity.isSelected = toggle;
              }
              this.$set(this.activities, index, activity);
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.activities.forEach((a, index) => {
          let activity = a;
          if (!activity.isPlanned) {
            activity.isSelected = toggle;
          }

          this.$set(this.activities, index, activity);
        });
      }
    },
    // Handle added activity from EditInput
    handleAdd(newActivity) {
      // this.activities.unshift(newActivity);
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          const company = response.data;
          // get index of selected project
          const indexOfProject = company.projects.findIndex(
            (p) => p._id === this.projectId
          );

          company.projects[indexOfProject].activities.unshift(newActivity);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success('Успешно добавяне на нова дейност!');
              this.$parent.$emit('getActivitiesAgain');
              this.closeEditItemWithPartModal();
            })
            .catch((error) => {
              console.log(error);
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
            });
        })
        .catch((error) => console.log(error));
    },
    editActivity(i) {
      this.selectedIndex = i;
      this.isEditItemWithPartOpen = true;
    },
    handleEditActivity(a) {
      this.activities[this.selectedIndex].name = a.name;
      this.activities[this.selectedIndex].unit = a.unit;
      this.activities[this.selectedIndex].price = a.price;
      this.activities[this.selectedIndex].part = a.part;
      this.activities[this.selectedIndex].updateInReports = true;

      this.$set(
        this.activities,
        this.selectedIndex,
        this.activities[this.selectedIndex]
      );
    },
    closeEditItemWithPartModal() {
      this.isEditItemWithPartOpen = false;
      this.selectedIndex = null;
    },
    deleteActivity(i) {
      this.activities.splice(i, 1);
    },
    getSelectedActivities() {
      return this.activities.filter((a) => {
        return a.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddActivitiesModal');
    },
    save() {
      if (this.isComingFromReport) {
        const sa = this.getSelectedActivities();

        for (let a of sa) {
          if (a.isSelected && !a.part) {
            return this.$snotify.error(
              'Трябва да изберете част за всяка избрана дейност'
            );
          }
        }

        this.$parent.$emit('saveAddActivitiesModal', sa);
      } else {
        this.$parent.$emit('saveAddActivitiesModal', this.activities);
      }
    },
    initActivities() {
      const selected = [];

      if (this.newestActivity) {
        for (let a of this.activities) {
          if (a.isSelected) {
            selected.push(a._id);
          }
        }
      }

      this.activities = this.$cloneDeep(this.incomingActivities);

      if (this.newestActivity) {
        for (let i = 0; i < this.activities.length; i++) {
          if (
            selected.indexOf(this.activities[i]._id) > -1 ||
            this.activities[i]._id === this.newestActivity
          ) {
            this.activities[i].isSelected = true;
          } else {
            this.activities[i].isSelected = false;
          }
          this.$set(this.activities, i, this.activities[i]);
          this.$parent.$emit('clearNewestActivity');
        }
      }

      this.activities.map((a) => {
        if (typeof a.plannedItems === 'number') {
          a.isPlanned = true;
        }
        if (!a.part) {
          this.$set(a, 'part', '')
        }
      });

      this.activities.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        // this.save();
      } else if (e.code === 'Escape') {
        this.close();
      }
    },
  },
  mounted() {
    this.initActivities();

    if (this.toggleImport) {
      this.triggerFileInput();
    }

    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEvents);
  },
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
.desktop {
  display: initial;
}
.mobile {
  display: none;
}
.modal-header .btns-select .btn {
  width: 100%;
}
.modal-content-item {
  height: initial;
  padding-bottom: 5px;
  padding-top: 5px;
}
.modal-content-check {
  align-items: center;
}
.select-p {
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
}
.select-p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
